import { createContext, useContext } from "react";
import type { CorpusSummary } from "../../../api/content/corporaApi";
import type { LoadState } from "../../../shared/loading/useLoad";

/**
 * The corpora of the chosen project: the one worked in, and those the Documents sidebar
 * lists and loads (F20).
 */
export interface CorpusSelectionValue {
  /** `null` while no project is chosen. */
  readonly corpora: LoadState<readonly CorpusSummary[]> | null;
  /** The corpus worked in, at its latest version: the one last read from; `null` while there is none. */
  readonly selectedCorpus: CorpusSummary | null;
  readonly selectCorpus: (corpusId: string) => void;
  /** The corpora the sidebar leaves out of its lists, so it doesn't load them. New corpora are shown. */
  readonly hiddenCorpusIds: ReadonlySet<string>;
  readonly showCorpus: (corpusId: string, shown: boolean) => void;
  /** Read the corpora again, for example after an import made a new version. */
  readonly reloadCorpora: () => void;
}

export const CorpusSelectionContext = createContext<CorpusSelectionValue | null>(null);

export function useCorpusSelection(): CorpusSelectionValue {
  const value = useContext(CorpusSelectionContext);
  if (value === null) {
    throw new Error("useCorpusSelection must be used inside CorpusSelectionProvider.");
  }
  return value;
}
